/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-03T10:29:11.581
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentPublishChannelEditInit,
	getRentPublishChannelView
} from '@api/rentmanage/RentPublishChannel';

import {
listRentPublishChannelConfigInit,
listRentPublishChannelConfigByAuthorizations,
deleteRentPublishChannelConfig
} from '@api/rentmanage/RentPublishChannelConfig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentPublishChannelEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPublishChannelView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPublishChannelView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
